import SupplierRegistrationFormStore from '@supplierRegistration/stores/appStores/SupplierRegistrationFormStore';
import SupplierRegistrationThemeStore from '@supplierRegistration/stores/infraStores/SupplierRegistrationThemeStore';
import SupplierRegistrationCustomerDataStore from '@supplierRegistration/stores/appStores/SupplierRegistrationCustomerDataStore';
import SupplierRegistrationDocumentsStore from '@supplierRegistration/stores/appStores/SupplierRegistrationDocumentsStore';

export default class SupplierRegistrationAppStores {
  supplierRegistrationFormStore: SupplierRegistrationFormStore;
  supplierRegistrationCustomerDataStore: SupplierRegistrationCustomerDataStore;
  supplierRegistrationDocumentsStore: SupplierRegistrationDocumentsStore;

  constructor(themeStore: SupplierRegistrationThemeStore) {
    this.supplierRegistrationFormStore = new SupplierRegistrationFormStore();
    this.supplierRegistrationCustomerDataStore = new SupplierRegistrationCustomerDataStore(themeStore);
    this.supplierRegistrationDocumentsStore = new SupplierRegistrationDocumentsStore();
  }
}
